'use client';

import { OffersModalNewProvider } from 'components/shared/OffersModal';
import { useGlobalUI } from 'contexts/GlobalUIContext';
import IndiaLayout from 'components/performance-lab/buy/india/IndiaLayout';
// Statically imported (not ssr:false): this is the only commercial page for the
// Bengaluru lab, so crawlers must get server-rendered content. The india/ tree
// is SSR-safe — every window/document access sits in an effect or a handler.
import IndiaPerformanceLabsPage from 'components/performance-lab/buy/india/IndiaPerformanceLabsPage';

type PerformanceLabsBuyPageProps = {
  region: string;
};

const INPerformanceLabs = () => {
  useGlobalUI({ headerCollaspable: true });

  return (
    <>
      <OffersModalNewProvider>
        <IndiaLayout>
          <IndiaPerformanceLabsPage />
        </IndiaLayout>
      </OffersModalNewProvider>
    </>
  );
};

export default function PerformanceLabsBuyPage(
  props: PerformanceLabsBuyPageProps,
) {
  const { region } = props;
  const regionUpper = region.toUpperCase();

  if (regionUpper === 'IN') {
    return <INPerformanceLabs />;
  }

  // Non-India regions are redirected in the server page
  return null;
}
